import { Reducer } from "redux";
import { MatchState } from "../constants";
import {
  mapToMatchSmallSmall,
  removeDuplicateMatchDays,
  replaceOrAddResponseSingle,
  sameDay
} from "../../config/utils";
import { MatchActions, MatchActionTypes } from "../actions/types";
import { addMatchDays, generateHomeSections } from "../../config/matchSmallUtils";

const initialState: MatchState = {
  matchDays: [],
  matches: [],
  matchElements: undefined,
  homeMatches: {},
  leagueMatches: {},
  teamMatches: {},
  totw: [],
  matchScreens: {},
  error: null,
  status: "idle",
  statusMatchDays: "idle"
};

const reducer: Reducer<MatchState> = (
  // eslint-disable-next-line default-param-last
  state = initialState,
  action: MatchActions
) => {
  switch (action.type) {
    case MatchActionTypes.RESET: {
      return {
        matchDays: [],
        matches: [],
        matchElements: undefined,
        leagueMatches: {},
        teamMatches: {},
        homeMatches: {},
        matchScreens: {},
        error: null,
        status: "idle",
        statusMatchDays: "idle"
      };
    }
    case MatchActionTypes.FETCH_TOTW:
    case MatchActionTypes.FETCH_LEAGUE_MATCHES:
    case MatchActionTypes.FETCH_MATCH:
    case MatchActionTypes.FETCH_HOME_MATCHES:
    case MatchActionTypes.FETCH_LINEUP:
      return { ...state, status: "loading" };
    case MatchActionTypes.FETCH_MATCH_DAYS: {
      return { ...state, statusMatchDays: "loading" };
    }
    case MatchActionTypes.FETCH_HOME_MATCHES_SUCCESS: {
      return {
        ...state, status: "idle", homeMatches: {
          ...state.homeMatches,
          [action.payload.key]: generateHomeSections(action.payload.response, [], [])
        }
      };
    }
    case MatchActionTypes.REFRESH_MATCH: {
      const matchId = action.payload.response.id;
      const { league } = action.payload.response;
      const leagueId = league.id;
      const matchesIdx = state.matches.findIndex((m) => m.id === matchId);
      const { leagueMatches, matchElements } = state;

      if (matchElements && matchElements.id === leagueId) {
        const mIdx = matchElements.response.findIndex((m) => m.id === matchId);
        if (mIdx !== -1) {
          matchElements.response[mIdx].goal1 = action.payload.response.goal1;
          matchElements.response[mIdx].goal2 = action.payload.response.goal2;
        }
      }
      return {
        ...state,
        status: "idle",
        matches:
          matchesIdx === -1
            ? state.matches
            : state.matches.fill(
              action.payload.response,
              matchesIdx,
              matchesIdx + 1
            ),
        matchElements,
        leagueMatches
      };
    }
    case MatchActionTypes.REFRESH_MATCH_DAYS: {
      const { match } = action.payload;
      const { addDate, removeDate } = action.payload;
      const newMatchDays = addMatchDays(state.matchDays, addDate, removeDate);


      return {
        ...state,
        status: "idle",
        matches: replaceOrAddResponseSingle(match, state.matches),
        matchDays: newMatchDays
      };
    }
    case MatchActionTypes.FETCH_LINEUP_SUCCESS: {
      const { id, date, response } = action.payload;
      return {
        ...state,
        status: "idle",
        matches: state.matches.map((m) =>
          m.id === id
            ? {
              ...m,
              lineupTeam1: date === 1 ? response : m.lineupTeam1,
              lineupTeam2: date === 2 ? response : m.lineupTeam2
            }
            : m
        )
      };
    }
    case MatchActionTypes.FETCH_SUCCESS_MATCH_DAYS: {
      return {
        ...state,
        statusMatchDays: "idle",
        matchDays: removeDuplicateMatchDays(
          state.matchDays.concat(action.payload.map((m) => new Date(m)))
        )
      };
    }
    case MatchActionTypes.REMOVE_MATCH_DAY: {
      return {
        ...state,
        statusMatchDays: "idle",
        matchDays: state.matchDays.filter((d) => !sameDay(d, action.payload))
      };
    }
    case MatchActionTypes.RESTORE_MATCHDAYS: {
      return {
        ...state,
        statusMatchDays: "idle",
        matchDays: []
      };
    }
    case MatchActionTypes.FETCH_SUCCESS_LEAGUE_MATCHES: {

      return {
        ...state,
        status: "idle",
        leagueMatches: {
          ...state.leagueMatches,
          [action.payload.key]: action.payload.response.map(mapToMatchSmallSmall)
        }
      };
    }
    case MatchActionTypes.FETCH_SUCCESS_MATCH_SCREEN: {
      return {
        ...state,
        status: "idle",
        matchScreens: {
          ...state.matchScreens,
          [action.payload.key]: action.payload.response
        }
      };
    }
    case MatchActionTypes.FETCH_SUCCESS_TEAM_MATCHES: {

      return {
        ...state,
        status: "idle",
        teamMatches: {
          ...state.teamMatches,
          [action.payload.key]: action.payload.response
        }
      };
    }
    case MatchActionTypes.FETCH_TOTW_SUCCESS: {
      const list = state.totw ? [...state.totw] : [];
      const idx = list.findIndex(
        (v) => v.id === action.payload.id && v.date === action.payload.date
      );
      if (idx >= 0) list[idx] = action.payload;
      else list.push(action.payload);
      return { ...state, status: "idle", totw: list };
    }
    case MatchActionTypes.FETCH_ERROR: {
      return {
        ...state,
        status: "failed",
        statusMatchDays: "failed",
        error: action.payload
      };
    }

    case MatchActionTypes.REFRESH:
      return {
        ...state,
        status: "idle",
        matches: state.matches.filter((m) => m.id !== action.payload)
      };
    default: {
      return state;
    }
  }
};

export { reducer as matchReducer };
